module.exports = __webpack_public_path__ + "static/ysk-bceace1bb05cb19071f0772db36c24c3.jpg";